import "./tablestyle.scss";
import { Grid, GridCellProps, GridColumn as Column, GridNoRecords} from "@progress/kendo-react-grid";
import { useState , useEffect} from "react";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import * as CONSTANTS from '../../utils/CONSTANTS';
import { useNavigate } from "react-router-dom";
import { updateCandidateStatus } from "./services";
import {SortDescriptor } from "@progress/kendo-data-query";
import { Icon } from '@iconify/react';
import mixpanelData, { userProfile } from "../../utils/mixpanel";
import RefereePayment from "../../modal/refereePayment";
import file_download from "../../assets/images/file_download.svg"
import { REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common";
import { postAPI } from "../../api/api";


const userLoginId = localStorage.getItem('loginId')

const ReferredTable = (props: any) => {

  const [modal, setModal] = useState<boolean>(false)
  const [notification, setNotification] = useState<boolean>(false)
  const [candidateLoginId, setCandidateLoginId] = useState<string>('')
  const [refereeId, setRefereeId] = useState<string>('')
  let newDate = new Date()
  const navigate = useNavigate()

  const initialSort: Array<SortDescriptor> = [
    { field: "", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);

  useEffect(() => {
    setModal(props.modal)
  }, [props.modal])

  const rowClick = (e: any) => {
    props.rowClick(e)

  }

  const getTableValues = () => {
    props.getResourceTables()

  }
 
    
      const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const redirection = (candidateLoginId: string) => {
    localStorage.setItem('candidateLoginId', candidateLoginId);
    localStorage.setItem('ResourcesCandidateLoginId', candidateLoginId);
    localStorage.setItem('ResourcesTab', '6');
    openInNewTab(`${window.location.origin}/createResources`)
    // navigate('../createResources', { state: { candidateLoginId: candidateLoginId, tab: 4 } })
  }

  const displayNotification = () => {
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 3000)
    }
    
    const onPaymentClick = (data: any) => {
      
      if(data.jobAppliedOn !== null && data.paymentStatus === null){
        setModal(true)
        setCandidateLoginId(data.loginId)
        setRefereeId(data.refereeId)
      }
    }

    const paymentCell = (props: GridCellProps) => {
        return (
            <td onClick={() => {onPaymentClick(props.dataItem)}}>
            {props.dataItem.jobAppliedOn !== null ? props.dataItem.paymentStatus !== null ?
              
              <div>Paid <br></br>
                {props.dataItem.paymentAmount + ' ' + props.dataItem.paymentCurrency + ' - ' + new Date(parseInt(props.dataItem.paymentDate)).toDateString().slice(3) }
              </div>
              :
              'Eligible' : 'Not Eligible'}
            </td>
        )
    }

    const submitPayment = (data: any) => {

    let payload = {
        "candidateLoginId": candidateLoginId,
        "refereeId": refereeId,
        "paymentAmount": data.paymentAmount,
        "paymentCurrency": data.paymentCurrency,
        "paymentDate": data.paymentDate
        }
        props.paymentSubmit(payload)
    }

    const referredOnDate = (props: GridCellProps) => {
        return (
            <td>
                {props.dataItem.referredOn && new Date(parseInt(props.dataItem.referredOn)).toDateString().slice(3)}
            </td>
        )
    }

    const gotOfferOn = (props: GridCellProps) => {
      return (
        <td>
          {props.dataItem.jobAppliedOn && props.dataItem.jobAppliedOn !== null ?  new Date(parseInt(props.dataItem.jobAppliedOn)).toDateString().slice(3) : 'Not Mentioned'}
        </td>
      )
  }
  
  const refereeCell = (props: GridCellProps) => {
    return (
      <td>
        <div>
          {props.dataItem.refereeName}
          <div className="email">{props.dataItem.refereeEmail}</div>
        </div>
      </td>
    )
  }

  return (
    <>
      <Grid
        data={props.state.items}
        onPageChange={props.pageChange}
        total={props.state.total}
        skip={props.state.skip}
        pageable={props.state.pageable}
        pageSize={props.state.pageSize}
        onItemChange={props.itemChange}
        onRowClick={(e) => rowClick(e)}
        // data={props.state.items && orderBy(props.state.items, sort)}
        // onSortChange={(e: GridSortChangeEvent) => {
        //   setSort(e.sort); props.getTableValues()
        // }}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
          props.setSort(e.sort);
          props.applySort(e.sort);

        }}
      >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
           <Column field="name" title="Name" width="180" className="noWordWrap" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId))} />
           <Column field="refereeName" title="Referee" cell={refereeCell} width="180"/>
           <Column field="referredOn" title="Referred On" cell={referredOnDate} />
           <Column field="referredJob" title="Referred For" />
           <Column field="gotOfferOn" title="Got Offer On"  cell={gotOfferOn}/>
           <Column field="ellowStatus" title="ellow status" width='100'/>
        {/* <Column field="ellowStatus" title="ellow status" cell={(props: GridCellProps) => ellowStatusDropdown(props, () => getTableValues(), () => rejected(props), () => blackListed(props))} /> */}
           <Column field="payment" title="Payment" cell={paymentCell} />
           <Column cell={downloadResume} width="120px" />
          </Grid>
        {modal && <RefereePayment onClose={() => setModal(false)} ClickHandler={submitPayment}/>}
    </>
  )
}

export default ReferredTable;


const downloadResume = (props: GridCellProps) => {

  return (
    <td>
      <img src={file_download} onClick={() => downloadData(props)} alt='' className="downloadButton"/>
    </td>
  );
}


const downloadData = (props: any) => {

  let fileName=props.dataItem.resumeFileName;
  let value = {
    "action":"getObject",
    "filename":fileName,
    "bucketName":"ellow-prod-doc-upload",
  };
  postAPI(REACT_APP_CANDIDATE_FRELLANCER +'/resume-signed-url',value).then((data) => {
    let signedUrl = data.url;
   fileName = decodeURIComponent(fileName.slice(36, fileName.length))  
  
  fetch(signedUrl).then((response: any) => {
    response.blob().then((blob: any) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download =fileName;
        alink.click();
    })
})
});
}


const openInNewTab = (url: any) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};


const nameCell = (props: GridCellProps, redirection: any) => {

  let currentDate = new Date().getTime()
  let dateOfRegistration = props.dataItem.dateOfRegistration
  var diff = (currentDate - dateOfRegistration) / 1000;
  diff /= (60 * 60);
  let diff2 = Math.abs(Math.round(diff));

  const profileImage = props.dataItem.googleProfileImage ? props.dataItem.googleProfileImage : " "

  return (
    <td className="statusWrap">
      {diff2 <= 24 &&
        <span className="userStatus">New</span>
      }
      <div className="userInfo" onClick={() => redirection(props.dataItem.loginId)}>
        {profileImage === " " ?
          <figure>{props.dataItem && props.dataItem.firstName && props.dataItem.firstName[0]}{props.dataItem && props.dataItem.lastName && props.dataItem.lastName[0]}</figure>
          :
          <figure><img src={profileImage}></img></figure>
        }
        <div>
          {props.dataItem.firstName + " " + props.dataItem.lastName}
          <div className="email">{props.dataItem.email}</div>
          <div className="phone">{props.dataItem.phoneNumber}</div>
        </div>
      </div>
    </td>
  )
}


const ellowStatusDropdown = (props: GridCellProps, getTableValues: any, rejected: any, blackListed: any) => {

  const { dataItem } = props;
  const field = props.field || '';

  const dataValue = dataItem[field] === null ? '' : dataItem[field];


  const updateStatus = (data: any) => {

    let value = {
      "loginId": props.dataItem.loginId,
      "userLoginId": userLoginId,
      "candidateStatus": data
    }
    
    updateCandidateStatus(value).then((response) => {
      if (response && response.status === 1) {
        getTableValues()
        mixpanelData('TG- Ellow status updated', {
          'source': 'Recruiter updates ellow status of candidate',
          'Ellow status': 'F3 - Verified'
        })
        mixpanelData('New TG - Ellow status updated', {
          'Source': 'Recruiter chnages status of a candidate',
          'Candidate name': `${response && response.data[0].profile_metadata && response.data[0].profile_metadata.firstName} ${response && response.data[0].profile_metadata && response.data[0].profile_metadata.lastName}` ,
          'Candidate email': response && response.data[0].profile_metadata && response.data[0].profile_metadata.email,
          'Candidate loginid': response && response.data[0].login_id,
          'distinct_id': localStorage.getItem('Email'),
          'ellow status': 'F3 - Verified',
          'Sourced by name': response && response.data[0] && response.data[0].behalfOfName,
          'Sourced by type': response && response.data[0].sourced_by,
          'Recruiter Email': localStorage.getItem('Email'),
        })
        userProfile({
          'ellow status': 'F3 - Verified'
        }, response && response.data[0].login_id)
      }
    })
  }

  const handleChange = (e: DropDownListChangeEvent) => {
    if (e.value.name === 'F3 - Verified') {
      updateStatus(e.target.value.id)
    }
    if (e.value.name === 'F99 - Rejected') {
      rejected()
    }
    if (e.value.name === 'F100- Blacklisted') {
      blackListed()
    }
  }


  return (
    <td>
      {dataItem && dataItem.inEdit ? (
        <DropDownList
          style={{ width: "100%" }}
          data={CONSTANTS.candidateStatus}
          onChange={handleChange}
          dataItemKey='id'
          textField="name"
        />
      ) : (dataValue)}
    </td>
  )
}

